export default {
    httpUrl: 'http://start.91huadd.com:28080/EnnEnergy/',
    imgUrl: 'http://start.91huadd.com:28080',
    frameworkUrl: 'http://startto.91huadd.com/api/',
    ryHttpUrl: 'http://47.95.2.23:8089/', 

    //测试
    // httpUrl: 'http://123.56.220.150:28080/EnnEnergy/',
    // httpUrl: 'http://192.168.8.124:28080/EnnEnergy_API/',
    // ryHttpUrl: 'http://123.56.220.150:8088/',
    // imgUrl: 'http://123.56.220.150:8080',
    // frameworkUrl: 'http://8.140.4.174:8000/api/',

    orgCode: '9115040377612641X1',
    orgName: '赤峰瑞阳化工有限公司',

    productList:[],

    //是否登录
    isLogin: '0',
    //登录用户Id
    userId: '',
    nickname: '',
    //用户名称
    userName: '',
    //用户手机号
    telNum: '',
    //登录用户权限
    permission: '',
    isPerson: '2',
    //公司认证
    isNotCertified: '',
    //个人认证
    isNotCertifiedPerson: '',
    //商品种类列表
    shopTypeList: [],
    //个人信息
    userInfo: '',
    //接口请求失败
    msg: '网络连接超时',
    //发布需要的参数
    //发布时选择的商品名称
    productName: '甲醇',
    //发布时选择的商品Id
    productId: '1000000000000000',
    //发布时选择的商品二级菜单名称
    mMsg: ' ',
    //发布时选择的商品二级菜单code
    mCode: ' ',

    //发布时选择的地址
    location: '',
    //发布时选择的黑白名单列表
    BlackOrwhite: '',
    participants: [],
    participantsList: [],
    allNum: '',
    whiteListType: false,
    //我的交易中，已结束，发布的筛选开关
    urlHistory: 0,
    target: '',
    underwayFiltrate: false,
    doneFiltrate: false,
    publishFiltrate: false,
    //认证
    //变更价格刷新
    changeBrushing: false,
    //设置title
    setTitle: '',
    //企业工商号
    companyCode: '',
    businessNo: ''
}



// WEBPACK FOOTER //
// ./src/store/state.js